module.exports = __webpack_public_path__ + "static/media/toni-hukkanen-GeWnWHgGXls-unsplash.6e108689.jpg";